import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import * as PropTypes from 'prop-types';
import { FontIcon, Link, Text, mergeStyleSets, Stack } from '@fluentui/react';
import { numberToLocaleString } from '@shared/utils/localeUtils';
import { CommunicationColors } from '@fluentui/theme';
import { Constants } from '@shared/utils/constants';
import { SpzaInstrumentService } from 'services/telemetry/spza/spzaInstrument';
import { withRouter } from '@shared/routerHistory';
import { logger } from '@src/logger';
const contentStyles = mergeStyleSets({
    linkedinSection: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 8
    },
    linkedinLogoIcon: {
        width: 18,
        height: 18,
        padding: 0,
        lineHeight: 20,
        verticalAlignment: 'center',
        color: CommunicationColors.primary
    },
    linkedinMembersText: {
        marginLeft: 6,
        fontSize: 14,
        lineHeight: 20,
        fontWeight: 400
    },
    linkedinLink: {
        marginLeft: 8,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        textDecoration: 'none'
    },
    linkedinLinkText: {
        fontSize: 14,
        fontWeight: 400,
        textDecoration: 'underline'
    },
    externallinkIcon: {
        paddingLeft: 4,
        width: 13,
        height: 13,
        color: CommunicationColors.primary,
        lineHeight: 20
    }
});
const LinkedinProductGroupBarFunction = ({ linkedInProductGroup, locale, countryCode, location }, context)=>{
    const onLinkClick = ()=>{
        const payload = {
            page: location === null || location === void 0 ? void 0 : location.pathname,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.LinkedinLink,
            details: JSON.stringify({
                offerId: linkedInProductGroup.offerId
            })
        };
        SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
        logger.info(payload.details, {
            page: payload.page,
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    };
    return /*#__PURE__*/ _jsxs(Stack, {
        className: contentStyles.linkedinSection,
        children: [
            /*#__PURE__*/ _jsx(FontIcon, {
                iconName: "LinkedInLogo",
                className: contentStyles.linkedinLogoIcon
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: contentStyles.linkedinMembersText,
                children: context.locParams('Linkedin_Members', [
                    numberToLocaleString({
                        number: linkedInProductGroup.membersCount,
                        locale,
                        countryCode
                    })
                ])
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        className: contentStyles.linkedinLink,
                        href: linkedInProductGroup.detailsUrl,
                        target: "_blank",
                        onClick: onLinkClick,
                        children: /*#__PURE__*/ _jsxs(Text, {
                            className: contentStyles.linkedinLinkText,
                            children: [
                                " ",
                                context.loc('Explore_Group_On_Linkedin')
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(FontIcon, {
                        iconName: "OpenInNewWindow",
                        className: contentStyles.externallinkIcon
                    })
                ]
            })
        ]
    });
};
export const LinkedinProductGroupBar = withRouter(LinkedinProductGroupBarFunction);
LinkedinProductGroupBarFunction.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
